import {
  Account, AccountFilters, ParentAccount, QueryResult,
} from '../types';
import api from '../api';

export default {
  find(id: string): Promise<Account> {
    return api.get(`accounts/${id}`).then(response => response.data);
  },
  findAll(parentId: string, filters: AccountFilters): Promise<QueryResult> {
    return api
      .get(`accounts/${parentId}/accounts`, { params: filters })
      .then(response => response.data);
  },
  getParent(id: string): Promise<ParentAccount> {
    return api
      .get(`accounts/${id}/parent`)
      .then(response => response.data);
  },
};
